import { motion } from "framer-motion";

export default function Regrowth() {
  return (
    <section className="relative overflow-hidden" data-testid="regrowth">
      {/* Background video (drop /forest-bg.mp4 into public to activate) with image poster fallback */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        poster="/forest-poster.jpg"
        data-testid="regrowth-bg-video"
      >
        <source src="/forest-bg.mp4" type="video/mp4" />
      </video>

      {/* Dark gradient overlay for text legibility */}
      <div className="absolute inset-0 bg-gradient-to-t from-background via-background/75 to-background/45" />
      <div className="absolute inset-0 bg-background/35" />

      <div className="relative px-6 md:px-12 max-w-5xl mx-auto py-28 sm:py-36 flex flex-col items-end text-right">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl"
        >
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-forest-light">The Comeback</span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-display font-bold tracking-tight">
            And from the <span className="text-red-500">ashes</span>, a <span className="text-emerald-400">forest</span> returns.
          </h2>
          <p className="mt-6 text-base sm:text-lg text-muted-foreground max-w-2xl ml-auto leading-relaxed">
            New roots break through scorched ground. Canopies rise where smoke once hung.
            Communities come home. This is the ending we're funding — green, alive, and growing.
          </p>
          <p className="mt-5 text-lg sm:text-xl font-display font-semibold text-foreground max-w-2xl ml-auto leading-relaxed">
            Every $AFTBRN token helps write it — real trees replanted, real recovery,
            <span className="text-forest-light"> verifiable on-chain.</span>
          </p>
          <p className="mt-6 font-mono text-sm text-muted-foreground/80">
            🌱 Turning <span className="text-red-500">ashes</span> into <span className="text-emerald-400">forests</span> — together.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
